'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  headline: null,
  avatar: null,
  companyAvatar: null,
  displayAvatarOption: null,
  publicDisplayAvatarOption: null
};

var DisplayInfo = /*#__PURE__*/function (_Record) {
  _inherits(DisplayInfo, _Record);

  function DisplayInfo() {
    _classCallCheck(this, DisplayInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(DisplayInfo).apply(this, arguments));
  }

  _createClass(DisplayInfo, null, [{
    key: "from",
    value: function from(json) {
      return new DisplayInfo(json);
    }
  }]);

  return DisplayInfo;
}(Record(defaults));

export { DisplayInfo as default };